import { Field, Form as FormikForm, Formik } from 'formik';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState, useRef, useEffect } from 'react';
import StaticModal from '../modal/staticModal';
import { Button } from 'react-bootstrap';
import Loader from '../loader';
// import '../styles.css';
import './style.css';

type Props = {
  isCouponPopupDisplayed: boolean;
  isPanVerficationRequired?: boolean;
  couponList: any;
  onKYCPopupClose?: () => void;
  closeModal?: () => void;
  hideModal?: () => void;
  onCouponApply?: (data) => void;
  onResetCoupon?: () => void;
  childFunc: any;
};

const CouponModal = React.forwardRef(
  ({
    isCouponPopupDisplayed,
    isPanVerficationRequired,
    onKYCPopupClose,
    closeModal,
    hideModal,
    couponList,
    onCouponApply,
    childFunc,
  }: Props) => {
    const [loading, setLoading] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState('');
    const [couponListData, setCouponListData] = useState([]);
    const [couponName, setCouponName] = useState('');
    const [inputCouponName, setInputCouponName] = useState('');

    useEffect(() => {
      setCouponListData(couponList?.data?.data);
    }, [couponList]);

    const onSelectCoupon = (value) => {
      setSelectedCoupon(value);
      setCouponName(value.name);
      setInputCouponName(value.name);
    };

    const onApplyCoupon = () => {
      // onCouponApply(selectedCoupon);
      onCouponApply(inputCouponName);
    };

    React.useEffect(() => {
      childFunc.current = onResetCoupon;
    }, []);

    const onResetCoupon = () => {
      setSelectedCoupon('');
      setCouponName('');
      setInputCouponName('');
    };

    const handleChange = (e) => {
      setInputCouponName(e.target.value);
    };

    const filteredData = couponListData?.filter((el) => {
      if (inputCouponName === '') {
        return el;
      } else {
        return (
          el.name.toLowerCase().includes(inputCouponName) ||
          el.name.toUpperCase().includes(inputCouponName)
        );
      }
    });

    return (
      <>
        {loading && <Loader />}
        <StaticModal
          show={isCouponPopupDisplayed}
          handleClose={onKYCPopupClose}
          title='Select coupon'
          onClose={() => {
            hideModal(), onResetCoupon();
          }}

          // size='lg'
        >
          <Formik
            // innerRef={ref}
            initialValues={{}}
            onSubmit={null}
          >
            {({}) => (
              <FormikForm>
                <div className='coupon-div'>
                  <InputGroup className='mb-3'>
                    <Form.Control
                      placeholder='Select below coupon'
                      aria-label="Recipient's username"
                      aria-describedby='basic-addon2'
                      value={inputCouponName}
                      onChange={(e) => handleChange(e)}
                      disabled={true}
                    />
                    {/* <Button
                      onClick={() => onApplyCoupon()}
                      variant='primary'
                      id='button-addon2'
                    >
                      Apply coupon
                    </Button> */}
                    <button
                      className='btn btn-verify'
                      id='button-pan'
                      type='button'
                      onClick={() => onApplyCoupon()}
                      disabled={inputCouponName === '' ? true : false}
                    >
                      Apply coupon
                    </button>
                  </InputGroup>
                </div>
              </FormikForm>
            )}
          </Formik>

          <div className='available-coupon'>
            {filteredData?.map((value) => (
              <div className='inner-coupon-div'>
                <Form.Check
                  type='radio'
                  label={value.name}
                  name='payment-group'
                  className='copon-radio'
                  onClick={(e) => onSelectCoupon(value)}
                  // checked={value.id===selecetdCoupon.id?true:false}
                ></Form.Check>
                <span className='coupon-des'>{value.description}</span>
              </div>
            ))}
          </div>
        </StaticModal>
      </>
    );
  }
);

export default React.memo(CouponModal);
